module.exports = __webpack_public_path__ + "img/acquadiparma1.82d3eac9.jpg";